import React from 'react';
import { PropTypes } from 'prop-types';
import CardMemberAvatar from '@atoms/CardMemberAvatar';
import {
    MessagesFromContainerStyled,
    MessageFromStyled,
    MessagesToContainerStyled,
    MessageToStyled,
    TimeStyled,
} from './ConversationWindowStyled';
import { formatTimeFriendly } from './helpers.date';

const ConversationMessage = ({ message, currentParticipantMember, viewerID }) => (
    <>
        {message.state.author === currentParticipantMember.id && (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    maxWidth: '90%',
                }}
            >
                <div style={{ marginRight: '10px' }}>
                    <div style={{ width: '48px' }}>
                        <CardMemberAvatar
                            firstName={currentParticipantMember.firstName}
                            lastName={currentParticipantMember.lastName}
                            photoURL={currentParticipantMember.photoURL}
                            sizeDesktop={48}
                            sizeMobile={48}
                        />
                    </div>
                </div>

                <MessagesFromContainerStyled>
                    <MessageFromStyled>
                        <div>{message.state.body}</div>
                    </MessageFromStyled>
                    <TimeStyled>{formatTimeFriendly(message.state.timestamp)}</TimeStyled>
                </MessagesFromContainerStyled>
            </div>
        )}

        {message.state.author === viewerID && (
            <MessagesToContainerStyled>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end' }}>
                    <MessageToStyled>
                        <div>{message.state.body}</div>
                    </MessageToStyled>
                </div>
                <TimeStyled style={{ alignSelf: 'flex-end' }}>{formatTimeFriendly(message.state.timestamp)}</TimeStyled>
            </MessagesToContainerStyled>
        )}
    </>
);

ConversationMessage.propTypes = {
    message: PropTypes.object,
    currentParticipantMember: PropTypes.object,
    viewerID: PropTypes.string,
};

export default ConversationMessage;
